import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from '@doccareplus/i18n';
import { selectIsAuthenticated, useAppSelector } from '@doccareplus/kernel/application';
import { PortalAuthLayout } from '../components/PortalAuthLayout';
import { PhoneOtpForm } from '../components/PhoneOtpForm';

// Patient portal registration — passwordless phone + WhatsApp OTP + name. Separate page from login.
export function PortalRegisterPage() {
  const { t } = useTranslation('portal');
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  useEffect(() => {
    if (isAuthenticated) navigate('/', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <PortalAuthLayout
      title={t('auth.registerTitle', 'Create your account')}
      subtitle={t('auth.registerSubtitle', 'Sign up with your phone number to get started.')}
      footer={
        <>
          {t('auth.haveAccount', 'Already have an account?')}{' '}
          <Link to="/login" className="font-semibold text-[var(--primary)] hover:underline">
            {t('auth.loginLink', 'Log in')}
          </Link>
        </>
      }
    >
      <PhoneOtpForm mode="signup" />
    </PortalAuthLayout>
  );
}
